import { TableCell, TableRow } from "@mui/material"

export function BreakdownRow({ item }) {
    return (
        <TableRow>
            <TableCell>{item.classification}</TableCell>
            <TableCell align="right">{item.included}</TableCell>
            <TableCell align="right">{item.excluded}</TableCell>
            <TableCell align="right">{item.modified}</TableCell>
        </TableRow>
    )
}
